(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-ugc-strip"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    var FEED_URL = 'https://gateway.getflowbox.com/v1/public/feed/';
    var LOCALES = { es: 'es-es', it: 'it-it', de: 'de-de', fr: 'fr-fr' };
    var POSTS_PER_PAGE = 29; // what flowbox.js asks for; the product's own posts come first
    var GIVE_UP_MS = 10000;
    var CDN = 'https://cdn.flbx.io/';
    var TILE_WIDTHS = [320, 640, 960];
    var TILE_SIZES = '49vw';
    var VIEWER_WIDTH = 1600; // px requested from the Flowbox CDN for the viewer
    var VIEWER_THUMB_WIDTH = 240;

    /**
     * Flowbox's resizing CDN: https://cdn.flbx.io/image/<base64 JSON> whose JSON
     * names the media (its feed url minus the CDN host) and the edits to apply.
     */
    function cdnImage(mediaKey, width) {
      var payload = { key: mediaKey, edits: { toFormat: 'webp', resize: { width: width } } };
      return CDN + 'image/' + btoa(JSON.stringify(payload)).replace(/\+/g, '-').replace(/\//g, '_');
    }

    /**
     * Re-encode a resizing CDN url at another width. Same approach as
     * ugc-gallery-toggle.js. Anything unexpected falls back to the url as given.
     */
    function atWidth(url, width) {
      var m = String(url).match(/^(https:\/\/[^/]+\/image\/)([A-Za-z0-9_=-]+)$/);
      if (!m) return url;
      try {
        var payload = JSON.parse(atob(m[2].replace(/-/g, '+').replace(/_/g, '/')));
        if (!payload.edits || !payload.edits.resize) return url;
        payload.edits.resize.width = width;
        delete payload.edits.resize.height;
        return m[1] + btoa(JSON.stringify(payload)).replace(/\+/g, '-').replace(/\//g, '_');
      } catch (e) {
        return url;
      }
    }

    /**
     * Product keys look like "<shop>_<SKU>_<catalog>". Keeps posts tagged with
     * this product alone: fallback posts carry other products' SKUs, and a post
     * tagged with several products has no way to say which of its photos shows
     * which one (Flowbox only tags the post as a whole).
     */
    function isOnlyTaggedWith(post, sku) {
      var keys = post.productKeys || [];
      return keys.length === 1 && keys[0].split('_').slice(1, -1).join('_') === sku;
    }

    /**
     * The product's own photos, in feed order, as { src, srcset, alt }: each
     * post's first image, or every image of it when allPhotos is set.
     */
    function ownPhotos(feed, sku, allPhotos) {
      var out = [];
      (feed.posts || []).forEach(function (post) {
        if (!isOnlyTaggedWith(post, sku)) return;

        var images = (post.media || []).filter(function (m) {
          return m.type === 'image' && m.url && m.url.indexOf(CDN) === 0;
        });
        if (!allPhotos) images = images.slice(0, 1);

        var alt = post.altText && post.altText[0];
        images.forEach(function (image) {
          var mediaKey = image.url.slice(CDN.length);
          out.push({
            src: cdnImage(mediaKey, 640),
            srcset: TILE_WIDTHS.map(function (w) {
              return cdnImage(mediaKey, w) + ' ' + w + 'w';
            }).join(', '),
            alt: (alt && alt.en) || ''
          });
        });
      });
      return out;
    }

    function buildTile(post, index) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'pdp-ugc-strip__tile';
      tile.setAttribute('data-index', index);

      var img = document.createElement('img');
      img.src = post.src;
      img.srcset = post.srcset;
      img.sizes = TILE_SIZES;
      img.alt = post.alt;
      img.loading = 'lazy';
      img.decoding = 'async';

      tile.appendChild(img);
      return tile;
    }

    /** The theme's product-photo viewer, opened on the clicked strip photo. */
    function openViewer(posts, index) {
      if (!window.theme || typeof theme.buildGalleryViewer !== 'function') return;

      var images = posts.map(function (post) {
        var thumb = document.createElement('img');
        thumb.className = 'pdp-ugc-viewer-thumb';
        thumb.src = atWidth(post.src, VIEWER_THUMB_WIDTH);
        thumb.alt = '';
        return { thumbTag: thumb, zoomUrl: atWidth(post.src, VIEWER_WIDTH) };
      });

      theme.buildGalleryViewer({
        images: images,
        currentImage: images[index].zoomUrl,
        prev: theme.icons.chevronLeft,
        next: theme.icons.chevronRight,
        close: theme.icons.close
      });
    }

    function initStrip(strip) {
      var track = strip.querySelector('[data-pdp-ugc-track]');
      if (!track || strip.dataset.bound) return;
      strip.dataset.bound = 'true';

      var posts = [];

      var finish = function (found) {
        posts = found;
        strip.ugcPosts = posts;

        // ugc-gallery-toggle.js waits on this verdict, so the gallery button
        // and the strip always agree on whether there is anything to show.
        strip.dataset.ugcState = posts.length ? 'ready' : 'empty';
        strip.dispatchEvent(
          new CustomEvent('pdp-ugc-strip:done', { bubbles: true, detail: { posts: posts.length } })
        );

        if (!posts.length) {
          strip.hidden = true;
          return;
        }

        var fragment = document.createDocumentFragment();
        posts.forEach(function (post, index) {
          fragment.appendChild(buildTile(post, index));
        });
        track.replaceChildren(fragment);
      };

      track.addEventListener('click', function (event) {
        var tile = event.target.closest('.pdp-ugc-strip__tile[data-index]');
        if (tile) openViewer(posts, Number(tile.getAttribute('data-index')));
      });

      afterLoadIdle(function () {
        var sku = strip.dataset.productId;
        var url =
          FEED_URL + encodeURIComponent(strip.dataset.flowKey) +
          '?postsPerPage=' + POSTS_PER_PAGE +
          '&productId=' + encodeURIComponent(sku) +
          '&locale=' + (LOCALES[strip.dataset.locale] || 'en-eu');
        var controller = 'AbortController' in window ? new AbortController() : null;
        var timer = setTimeout(function () {
          if (controller) controller.abort();
        }, GIVE_UP_MS);

        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function (response) {
            if (!response.ok) throw new Error('Flowbox feed ' + response.status);
            return response.json();
          })
          .then(function (feed) {
            var max = Number(strip.dataset.maxPhotos) || 12;
            finish(ownPhotos(feed, sku, strip.hasAttribute('data-all-photos')).slice(0, max));
          })
          .catch(function () {
            finish([]); // blocked, slow or down: no strip, no button
          })
          .then(function () {
            clearTimeout(timer);
          });
      });
    }

    /**
     * The feed waits until the page has loaded and the main thread is idle: it
     * must never compete with the gallery image (LCP) or the first interactions.
     * The skeleton holds the strip's space meanwhile, so the later fill shifts nothing.
     */
    function afterLoadIdle(callback) {
      var idle = function () {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(callback, { timeout: 2000 });
        } else {
          setTimeout(callback, 200);
        }
      };
      if (document.readyState === 'complete') {
        idle();
      } else {
        window.addEventListener('load', idle, { once: true });
      }
    }

    function initAll(root) {
      root.querySelectorAll('[data-pdp-ugc-strip]').forEach(initStrip);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
